import React from 'react';
import Switch from 'react-switch';
import { toast } from 'react-toastify';
import { notifyError } from '../../utils/toast';

const ShopSettings = ({ onChange }) => {
  const [swatch, setSwatch] = React.useState(tpwvs_admin_settings.tpwvs_shop.enable_swatches);
  const [swatchPosition, setSwatchPosition] = React.useState(tpwvs_admin_settings.tpwvs_shop.swatch_position);
  const [swatchLabel, setSwatchLabel] = React.useState(tpwvs_admin_settings.tpwvs_shop.swatch_label);
  const [swatchAlignments, setSwatchAlignMents] = React.useState(tpwvs_admin_settings.tpwvs_shop.swatch_alignments);
  const [swatchLimit, setSwatchLimit] = React.useState(tpwvs_admin_settings.tpwvs_shop.swatch_limit || 7);
  const [showSwatchInteractionLabel, setShowSwatchInteractionLabel] = React.useState(tpwvs_admin_settings.tpwvs_shop.show_swatch_interaction_label !== undefined ? tpwvs_admin_settings.tpwvs_shop.show_swatch_interaction_label : true);
  const [loading, setLoading] = React.useState(false);

  const notifyPreview = (updated) => {
    try {
      if (typeof onChange === 'function') onChange(updated);
      if (window && typeof window.tpwvsUpdateSettings === 'function') {
        window.tpwvsUpdateSettings(updated);
      } else {
        window.tpwvs_admin_settings = { ...(window.tpwvs_admin_settings || {}), ...updated };
        window.dispatchEvent(new CustomEvent('tpwvs_settings_updated', { detail: window.tpwvs_admin_settings }));
      }
    } catch (err) {
      // ignore
    }
  };

  const saveSettings = async (payload) => {
    const formData = new FormData();
    formData.append('action', 'tpwvs_update_settings');
    formData.append('security', tpwvs_admin_settings.update_nonce);
    if (payload.tpwvs_shop) {
      formData.append('tpwvs_shop', JSON.stringify(payload.tpwvs_shop));
    }

    const resp = await fetch(tpwvs_admin_settings.api_url, { method: 'POST', body: formData });
    toast.promise(resp.json(), {
      pending: {
        render() { setLoading(true); return 'Data is loading'; }, icon: true
      },
      success: {
        render({ data }) { setLoading(false); notifyPreview(payload); return data.data.message; }, icon: true
      },
      error: {
        render() { return notifyError('Api loaded failed'); }
      }
    });
  };

  const handleSwatchesToggle = (isChecked) => {
    const next = !swatch;
    setSwatch(next);
    const updated = { tpwvs_shop: { enable_swatches: next, swatch_position: swatchPosition, swatch_alignments: swatchAlignments, swatch_label: swatchLabel, swatch_limit: swatchLimit, show_swatch_interaction_label: showSwatchInteractionLabel } };
    saveSettings(updated);
  };

  const handleSwatcheLabel = (isChecked) => {
    const next = !swatchLabel;
    setSwatchLabel(next);
    const updated = { tpwvs_shop: { enable_swatches: swatch, swatch_position: swatchPosition, swatch_alignments: swatchAlignments, swatch_label: next, swatch_limit: swatchLimit, show_swatch_interaction_label: showSwatchInteractionLabel } };
    saveSettings(updated);
  };

  const handleSwatchPosition = (e) => {
    const value = e.target.value;
    setSwatchPosition(value);
    const updated = { tpwvs_shop: { enable_swatches: swatch, swatch_position: value, swatch_alignments: swatchAlignments, swatch_label: swatchLabel, swatch_limit: swatchLimit, show_swatch_interaction_label: showSwatchInteractionLabel } };
    saveSettings(updated);
  };

  const handleSwatchAlignments = (e) => {
    const value = e.target.value;
    setSwatchAlignMents(value);
    const updated = { tpwvs_shop: { enable_swatches: swatch, swatch_position: swatchPosition, swatch_alignments: value, swatch_label: swatchLabel, swatch_limit: swatchLimit, show_swatch_interaction_label: showSwatchInteractionLabel } };
    saveSettings(updated);
  };

  const handleSwatchLimit = (e) => {
    const value = parseInt(e.target.value, 10) || 7;
    setSwatchLimit(value);
    const updated = { tpwvs_shop: { enable_swatches: swatch, swatch_position: swatchPosition, swatch_alignments: swatchAlignments, swatch_label: swatchLabel, swatch_limit: value, show_swatch_interaction_label: showSwatchInteractionLabel } };
    saveSettings(updated);
  };

  const handleShowSwatchInteractionLabel = (isChecked) => {
    const next = !showSwatchInteractionLabel;
    setShowSwatchInteractionLabel(next);
    const updated = { tpwvs_shop: { enable_swatches: swatch, swatch_position: swatchPosition, swatch_alignments: swatchAlignments, swatch_label: swatchLabel, swatch_limit: swatchLimit, show_swatch_interaction_label: next } };
    saveSettings(updated);
  };

  React.useEffect(() => {
    const current = { tpwvs_shop: { enable_swatches: swatch, swatch_position: swatchPosition, swatch_alignments: swatchAlignments, swatch_label: swatchLabel, swatch_limit: swatchLimit, show_swatch_interaction_label: showSwatchInteractionLabel } };
    notifyPreview(current);
  }, [swatch, swatchPosition, swatchAlignments, swatchLabel, swatchLimit, showSwatchInteractionLabel]);

  return (
    <div className="tpv-settings-shop  h-[600px] overflow-auto">
      <div className="tpv-settings-option md:flex justify-between items-center pt-[26px] pb-[23px] px-9 border-[#F4F5F9] border-b-2 last:border-0">
        <div className="tpv-settings-option-content mb-4 md:mb-0">
          <h4 className="text-lg mb-0">Enable</h4>
          <p className="mb-0">Enable swatches for shop/archive page.</p>
        </div>
        <div className="tpv-settings-option-switch">
          <div className="flex md:justify-center items-center">
            <Switch onChange={handleSwatchesToggle} checked={swatch} className={`react-switch ${swatch ? 'active' : ''}`} uncheckedIcon={false} checkedIcon={false} id="material-switch" />
          </div>
        </div>
      </div>

      <div className="tpv-settings-option md:flex justify-between items-center pt-[26px] pb-[23px] px-9 border-[#F4F5F9] border-b-2 last:border-0">
        <div className="tpv-settings-option-content mb-4 md:mb-0">
          <h4 className="text-lg mb-0">Swatch label</h4>
          <p className="mb-0">Show/Hide swatches label for shop/archive page.</p>
        </div>
        <div className="tpv-settings-option-switch">
          <div className="flex md:justify-center items-center">
            <Switch onChange={handleSwatcheLabel} checked={swatchLabel} className={`react-switch ${swatchLabel ? 'active' : ''}`} uncheckedIcon={false} checkedIcon={false} id="material-switch" />
          </div>
        </div>
      </div>

      <div className="tpv-settings-option md:flex justify-between items-center pt-[26px] pb-[23px] px-9 border-[#F4F5F9] border-b-2 last:border-0">
        <div className="tpv-settings-option-content mb-4 md:mb-0">
          <h4 className="text-lg mb-0">Position</h4>
          <p className="mb-0">Swatches position on archive page. You also can use the shortcode. <div></div> <strong>Note:</strong> This setting will not work for Block themes. Please use this shortcode inside woocommerce loop: <code className="bg-[#F7F9FA] text-[#303136] h-7 px-2 inline-block">[pure_wc_swatches]</code></p>
        </div>
        <div className="tpv-settings-option-select tp-tooltip-select tp-position-select">
          <select onChange={handleSwatchPosition} className={swatchPosition} value={swatchPosition}>
            <option value={"after_title"}>After Title</option>
            <option value={"after_price"}>After Price</option>
          </select>
        </div>
      </div>

      <div className="tpv-settings-option md:flex justify-between items-center pt-[26px] pb-[23px] px-9 border-[#F4F5F9] border-b-2 last:border-0">
        <div className="tpv-settings-option-content mb-4 md:mb-0">
          <h4 className="text-lg mb-0">Swatch alignments</h4>
          <p className="mb-0">Swatches alignments in shop loop. Adjust the alignment according to your theme style.</p>
        </div>
        <div className="tpv-settings-option-select tp-tooltip-select tp-position-select">
          <select onChange={handleSwatchAlignments} className={swatchAlignments} value={swatchAlignments}>
            <option value={"left"}>Left</option>
            <option value={"right"}>Right</option>
            <option value={"center"}>Center</option>
          </select>
        </div>
      </div>

      <div className="tpv-settings-option md:flex justify-between items-center pt-[26px] pb-[23px] px-9 border-[#F4F5F9] border-b-2 last:border-0">
        <div className="tpv-settings-option-content mb-4 md:mb-0">
          <h4 className="text-lg mb-0">Swatch limit</h4>
          <p className="mb-0">Maximum number of swatches to display in shop loop. Additional swatches will show as "+N" badge linking to product details page.</p>
        </div>
        <div className="tpv-settings-option-input">
          <input type="number" min="1" max="50" onChange={handleSwatchLimit} value={swatchLimit} style={{ width: '80px', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
        </div>
      </div>

      <div className="tpv-settings-option md:flex justify-between items-center pt-[26px] pb-[23px] px-9 border-[#F4F5F9] border-b-2 last:border-0">
        <div className="tpv-settings-option-content mb-4 md:mb-0">
          <h4 className="text-lg mb-0">Show Swatch Interaction Labels</h4>
          <p className="mb-0">Display selected swatch name/label when user interacts with swatches on shop pages.</p>
        </div>
        <div className="tpv-settings-option-switch">
          <div className="flex md:justify-center items-center">
            <Switch onChange={handleShowSwatchInteractionLabel} checked={showSwatchInteractionLabel} className={`react-switch ${showSwatchInteractionLabel ? 'active' : ''}`} uncheckedIcon={false} checkedIcon={false} id="material-switch" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopSettings;
